import { Library, LibraryQuery } from 'types';
import apiClient from '../ApiClient';

export async function getLibraries(payload: LibraryQuery): Promise<Library[]> {
  return await apiClient.get('libraries', { params: payload }).then(response => {
    return response.data;
  });
}
